module.exports = __webpack_public_path__ + "img/Moodle.5ab0e76.svg";